import React from "react";
import { Form } from "antd";
import { typography } from "theme/Typography";

interface CustomFormProps {
  onFinish: (values: any) => void;
  onFinishFailed?: (errorInfo: any) => void;
  children: React.ReactNode;
  title?: string;
  className?: string;
  initialValues?: any;
  includeMarginTop?: boolean;
  form?: any;
  onValuesChange?: any;
}

const CustomForm: React.FC<CustomFormProps> = ({
  onFinish,
  onFinishFailed,
  children,
  title,
  className,
  initialValues,
  form,
  includeMarginTop = true,
  onValuesChange,
  ...others
}) => {
  const formStyle = {
    fontSize: typography.fontSizes.sm,
    ...(includeMarginTop && { marginTop: "20px" }),
  };

  return (
    <Form
      size="large"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      scrollToFirstError
      title={title}
      autoComplete="off"
      form={form}
      className={className}
      initialValues={initialValues}
      style={formStyle}
      onValuesChange={onValuesChange}
      {...others}
    >
      {children}
    </Form>
  );
};

export default CustomForm;
